module.exports = {
  defaultBlock: {
    title: "Insider Access to the World's Best Labs",
    showSubtitle: true,
    subtitle: "100% luxury—for a fraction of the cost.",
    icons: {
      title: "Beauty Pie members don't pay for: ",
      icons: [
        {
          icon: {
            title: "middlemen-shirt-icon-strikethrough",
            src: "//images.ctfassets.net/zhlj43mgv753/4twouGQlx7dFfr4Pf3i3v2/55c046a0ad0841aae15fe43efa320fb1/middlemen-shirt-icon-strikethrough.svg",
            id: "4twouGQlx7dFfr4Pf3i3v21",
          },
          label: "Middlemen1",
          __typename: "LandingPageIcon",
          id: "1UFRXnkg7TrsoNvj5R6gqZ",
        },
        {
          icon: {
            title: "middlemen-shirt-icon-strikethrough",
            src: "//images.ctfassets.net/zhlj43mgv753/4twouGQlx7dFfr4Pf3i3v2/55c046a0ad0841aae15fe43efa320fb1/middlemen-shirt-icon-strikethrough.svg",
            id: "4twouGQlx7dFfr4Pf3i3v22",
          },
          label: "Middlemen2",
          __typename: "LandingPageIcon",
          id: "1UFRXnkg7TrsoNvj5R6gqZ",
        },
        {
          icon: {
            title: "middlemen-shirt-icon-strikethrough",
            src: "//images.ctfassets.net/zhlj43mgv753/4twouGQlx7dFfr4Pf3i3v2/55c046a0ad0841aae15fe43efa320fb1/middlemen-shirt-icon-strikethrough.svg",
            id: "4twouGQlx7dFfr4Pf3i3v23",
          },
          label: "Middlemen3",
          __typename: "LandingPageIcon",
          id: "1UFRXnkg7TrsoNvj5R6gqZ",
        },
        {
          icon: {
            title: "middlemen-shirt-icon-strikethrough",
            src: "//images.ctfassets.net/zhlj43mgv753/4twouGQlx7dFfr4Pf3i3v2/55c046a0ad0841aae15fe43efa320fb1/middlemen-shirt-icon-strikethrough.svg",
            id: "4twouGQlx7dFfr4Pf3i3v24",
          },
          label: "Middlemen4",
          __typename: "LandingPageIcon",
          id: "1UFRXnkg7TrsoNvj5R6gqZ",
        },
      ],
      __typename: "IconsContainer",
      id: "aw2WgnCERrz41YoOTV3pc",
    },
    imageRef: {
      filename: "nav-kits-category-image.jpg",
      description: "Navigation Kits Category Image",
      src: "https://d2csxpduxe849s.cloudfront.net/media/192DFBC7-8953-4970-B7753853A910CFA9/77136640-9CF9-4AC8-8511E371F9C17E66/C17D675F-895A-43CB-B8E3FA8B373F5AEA/OTF%20BETA-boost_your_blowdry_kit_64828_CSL_secondary_1_WEB.jpg",
      __typename: "BynderAsset",
      id: "4gz1ltwT1fEjn5PpdDCXZQ",
    },
    cta: {
      id: "7DD41lfX4l3HSDLSEBFoNY",
      reference: "Hello Fresh - $15 off $50 With Free Trial",
      title: "Join Beauty Pie",
      link: "atb",
      backgroundColor: "Black",
      membershipId: "BP_TRIAL_60D_UK",
      discount: "15OFFHELLOFRESH",
    },
    link: {
      title: "Shop All",
      href: "/shop/bestsellers",
      __typename: "GeneralLink",
      id: "6RXG7stYgwDHYBjNdnW7iD",
    },
    imagePosition: "Left",
    trackingModule: { modulePosition: 1 },
    showRichText: true,
    richTextBody:
      "<p>Before BEAUTY PIE®, if you wanted the really good skincare, makeup, fragrances, haircare or bodycare, you’d have to shop at traditional retail, and overpay for all the markups (the layers).  </p><p>Now - you can have access to the best quality beauty and wellness products (from leading labs in France, Switzerland, Italy, Germany, Japan, Korea etc), direct, and get a bigger piece of the BEAUTY PIE. jsdf</p>",
    showIcons: true,
    showCta: true,
    showSubCta: false,
    backgroundColour: "Lightest Pink",
  },
  secondBlock: {
    title: "How does Beauty Pie do it?",
    showSubtitle: false,
    subtitle: "undefined",
    icons: undefined,
    imageRef: {
      id: "1Wi7yQ2giDfTBSF4nECqGI",
      filename: "price-split-eyeshadow-us.jpg",
      description: "price split eyeshadow us",
      bynderData: [
        {
          id: "71E045F4-CAB7-4F1D-8CC0EF4F4A00F071",
          src: "https://d2csxpduxe849s.cloudfront.net/media/192DFBC7-8953-4970-B7753853A910CFA9/71E045F4-CAB7-4F1D-8CC0EF4F4A00F071/webimage-A6F7A312-37D4-4C73-971DC3110DEE0343.png",
          name: "Q1 SUMMER AT BEAUTY PIE_MAY_Desktop_Module1_US",
          tags: [
            "Bronzing Summer Collection",
            "Bronzing 2024",
            "Awesome Bronze",
          ],
          type: "image",
          width: 720,
          height: 654,
          archive: 0,
          brandId: "6D3B2273-1494-42A0-89EA4318622F32E5",
          limited: 0,
          fileSize: 85913,
          isPublic: 0,
          original: null,
          copyright: null,
          extension: ["jpg"],
          thumbnails: {
            mini: "https://d2csxpduxe849s.cloudfront.net/media/192DFBC7-8953-4970-B7753853A910CFA9/71E045F4-CAB7-4F1D-8CC0EF4F4A00F071/mini-A16CFE04-F75C-48BE-B67232E933F81F52.png",
            thul: "https://d2csxpduxe849s.cloudfront.net/media/192DFBC7-8953-4970-B7753853A910CFA9/71E045F4-CAB7-4F1D-8CC0EF4F4A00F071/thul-CD7BA771-979C-471D-A1E5A0944E3BC126.png",
            swatch:
              "https://d2csxpduxe849s.cloudfront.net/media/192DFBC7-8953-4970-B7753853A910CFA9/71E045F4-CAB7-4F1D-8CC0EF4F4A00F071/27B49701-A5F7-4E9E-97B7E88C0ED15B8D/swatch-Q1%20SUMMER%20AT%20BEAUTY%20PIE_MAY_Desktop_Module1_US.jpg",
            "OTF BETA":
              "https://d2csxpduxe849s.cloudfront.net/media/192DFBC7-8953-4970-B7753853A910CFA9/71E045F4-CAB7-4F1D-8CC0EF4F4A00F071/27B49701-A5F7-4E9E-97B7E88C0ED15B8D/OTF%20BETA-Q1%20SUMMER%20AT%20BEAUTY%20PIE_MAY_Desktop_Module1_US.jpg",
            webimage:
              "https://d2csxpduxe849s.cloudfront.net/media/192DFBC7-8953-4970-B7753853A910CFA9/71E045F4-CAB7-4F1D-8CC0EF4F4A00F071/webimage-A6F7A312-37D4-4C73-971DC3110DEE0343.png",
          },
          dateCreated: "2024-05-31T09:25:39Z",
          description: null,
          orientation: "landscape",
          watermarked: 0,
          dateModified: "2024-05-31T09:28:05Z",
          datePublished: "2024-05-31T09:24:37Z",
          videoPreviewURLs: [],
          textMetaproperties: [],
        },
      ],
      $$contentfulEntry: {},
    },
    cta: {
      id: "3XnvTxUBcjkOkbpLTjQcL0",
      reference: "Join And Start Saving - Push to steps module",
      title: "Join And Start Saving",
      link: "#want-to-shop-at-members-prices",
      backgroundColor: "Pink",
      $$contentfulEntry: {},
    },
    link: {
      id: "6RXG7stYgwDHYBjNdnW7iD",
      title: "Shop All",
      url: "/shop/bestsellers",
      $$contentfulEntry: {},
    },
    imagePosition: "Right",
    trackingModule: { modulePosition: 1 },
    showRichText: true,
    richTextBody:
      "<p>Before BEAUTY PIE®, if you wanted the really good skincare, makeup, fragrances, haircare or bodycare, you’d have to shop at traditional retail, and overpay for all the markups (the layers).  </p><p>Now - you can have access to the best quality beauty and wellness products (from leading labs in France, Switzerland, Italy, Germany, Japan, Korea etc), direct, and get a bigger piece of the BEAUTY PIE. jsdf</p>",
    showIcons: false,
    showCta: true,
    showSubCta: true,
    backgroundColour: "Gray",
  },
  videoBlock: {
    title: "There's No Catch?",
    showSubtitle: false,
    subtitle: "undefined",
    icons: {
      title: "Beauty Pie members don't pay for: ",
      icons: [
        {
          icon: {
            title: "middlemen-shirt-icon-strikethrough",
            src: "//images.ctfassets.net/zhlj43mgv753/4twouGQlx7dFfr4Pf3i3v2/55c046a0ad0841aae15fe43efa320fb1/middlemen-shirt-icon-strikethrough.svg",
            id: "4twouGQlx7dFfr4Pf3i3v21",
          },
          label: "Middlemen1",
          __typename: "LandingPageIcon",
          id: "1UFRXnkg7TrsoNvj5R6gqZ",
        },
        {
          icon: {
            title: "middlemen-shirt-icon-strikethrough",
            src: "//images.ctfassets.net/zhlj43mgv753/4twouGQlx7dFfr4Pf3i3v2/55c046a0ad0841aae15fe43efa320fb1/middlemen-shirt-icon-strikethrough.svg",
            id: "4twouGQlx7dFfr4Pf3i3v22",
          },
          label: "Middlemen2",
          __typename: "LandingPageIcon",
          id: "1UFRXnkg7TrsoNvj5R6gqZ",
        },
        {
          icon: {
            title: "middlemen-shirt-icon-strikethrough",
            src: "//images.ctfassets.net/zhlj43mgv753/4twouGQlx7dFfr4Pf3i3v2/55c046a0ad0841aae15fe43efa320fb1/middlemen-shirt-icon-strikethrough.svg",
            id: "4twouGQlx7dFfr4Pf3i3v23",
          },
          label: "Middlemen3",
          __typename: "LandingPageIcon",
          id: "1UFRXnkg7TrsoNvj5R6gqZ",
        },
        {
          icon: {
            title: "middlemen-shirt-icon-strikethrough",
            src: "//images.ctfassets.net/zhlj43mgv753/4twouGQlx7dFfr4Pf3i3v2/55c046a0ad0841aae15fe43efa320fb1/middlemen-shirt-icon-strikethrough.svg",
            id: "4twouGQlx7dFfr4Pf3i3v24",
          },
          label: "Middlemen4",
          __typename: "LandingPageIcon",
          id: "1UFRXnkg7TrsoNvj5R6gqZ",
        },
      ],
      __typename: "IconsContainer",
      id: "aw2WgnCERrz41YoOTV3pc",
    },
    imageRef: {
      id: "6YhQLG8Wv3DszBTI8s5WWS",
      title: "BVOD video",
      videoLink:
        "https://www.youtube.com/embed/LdgpX7pj9Bc?si=jLseOqr9UPoUO1kS",
      ratio: "Widescreen (16:9)",
      $$contentfulEntry: {},
    },
    cta: {
      id: "5eQImF6pnaNGDCP8C8DR10",
      reference: "Shop Youthbomb Body - Adds product + AP ",
      title: "Shop Youthbomb™ Body",
      link: "/basket?items=[m:BP_TRIAL_60D_UK:1,p:195694:1]&source=site",
      backgroundColor: "Pink",
      $$contentfulEntry: {},
    },
    link: undefined,
    imagePosition: "Right",
    trackingModule: { modulePosition: 1 },
    showRichText: true,
    richTextBody:
      "<p>Before BEAUTY PIE®, if you wanted the really good skincare, makeup, fragrances, haircare or bodycare, you’d have to shop at traditional retail, and overpay for all the markups (the layers).  </p><p>Now - you can have access to the best quality beauty and wellness products (from leading labs in France, Switzerland, Italy, Germany, Japan, Korea etc), direct, and get a bigger piece of the BEAUTY PIE. jsdf</p>",
    showIcons: true,
    showCta: true,
    showSubCta: false,
    backgroundColour: "White",
  },
}
